import moment from 'moment/moment'
import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import maxDate from '@smartcoop/forms/validators/maxDate.validator'
import required from '@smartcoop/forms/validators/required.validator'
import { momentBackDateFormat } from '@smartcoop/utils/dates'

const registerAnimalBirth = ({ t, props }) => Yup.object().shape({

  expectedDate: flow(
    required({ t })
  )(Yup.string()),

  occurrenceDate: flow(
    required({ t }),
    maxDate({ t, maxReceiptDate: moment().format(momentBackDateFormat), text: t('ocurrence date cannot be a future period') })
  )(Yup.string()),

  gender: flow(
    required({ t })
  )(Yup.string()),

  isAlive: flow(
    required({ t })
  )(Yup.string()),

  lotId: flow(
    required({ t })
  )(Yup.string()),

  weight: Yup.string().when('isAlive', (isAlive, schema) => {
    if ((isAlive === true || isAlive === 'true') && props?.gender === 'femea') {
      return schema.required(t('weight is required to alive females'))
    }

    return schema.nullable()
  }),

  birthType: flow(
    required({ t })
  )(Yup.string())

})

export default registerAnimalBirth
